import { Card, Grid } from '@mui/material';
import dayjs from 'dayjs';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Spinner } from "reactstrap";
import { payrollReportsHeader } from "../../../store/headers/action";
const Header = (props) => {
  const { data, title, onReRunPayroll, loading } = props;
  const [socketResponse, setSocketResponse] = useState();
  const dispatch = useDispatch()
  const { getPayrollHeader } = useSelector(state => state?.PayrollHeaderReducer);


  useEffect(() => {
    if (data && data !== null && data?.length > 0) {
      dispatch(payrollReportsHeader(data[0]?.RunYear_ID))

    }
  }, [data])
  const connectWebSocket = () => {
    onReRunPayroll();
    const newSocket = new WebSocket(process.env.REACT_APP_API_WSS_URL);

    newSocket.onopen = () => {
      console.log('WebSocket connection opened');
    };

    // newSocket.onclose = () => {
    //     console.log('WebSocket connection closed');
    //     setSocket(null);
    //     setConnected(false);
    // };
    newSocket.onmessage = (event) => {
      // Parse the incoming message (assuming it's JSON)
      const data = JSON.parse(event.data);
      console.log('Received data:', data);
      setSocketResponse(data)

    };
    newSocket.onerror = (error) => {
      console.error(`WebSocket Error: ${error}`);

    };
  };

  if (!data || data.length === 0) {
    return <div></div>;
  }
  const { ppe, ppeEnddate, check_Date, departmentName, runDate, runTime, start_Time } = getPayrollHeader && getPayrollHeader.length > 0 && getPayrollHeader[0] || [];







  return (
    <>
      {socketResponse && socketResponse.length > 0 ? (
        <Card style={{
          marginBottom: "14px"
        }}>
          <p
            style={{
              background: "black",
              color: "white",
              fontSize: "16px",
              padding: "6px",
            }}
          >
            <table>
              <tbody>
                <tr >
                  {" "}
                  <td style={{ textAlign: "left" }}>
                    Run Date -{" "}
                    {dayjs(socketResponse[0].Start_Time).format(
                      "MM/DD/YYYY hh:mm A"
                    )}
                  </td>
                </tr>
                <tr>
                  {" "}
                  <td style={{ textAlign: "left" }}>Run Year & ID - {socketResponse[0].Run_Year} ,{socketResponse[0].Run_ID}</td>
                </tr>
                <tr>
                  {" "}
                  <td style={{ textAlign: "left" }}>Status - {socketResponse[0].Payroll_Status}</td>
                </tr>
                <tr>
                  {" "}
                  <td style={{ textAlign: "left" }}>Remarks - {socketResponse[0].Remarks}</td>
                </tr>
                <tr>
                  <td style={{ textAlign: "left" }}>PPE -{socketResponse[0].PPE}</td>
                </tr>
              </tbody>
            </table>
            {/* {socketResponse} */}
          </p>
        </Card>
      ) : socketResponse && socketResponse.length === 0 ? <p style={{
        textAlign: "center",
        background: "black",
        color: "white",
        fontSize: "16px",
        padding: "6px",
      }}
        className="dark-mode">Started in background</p> : ""}
      <div style={{ width: "100%", margin: '10px auto ' }}>
        <Grid container style={{ width: '90%', margin: 'auto' }} spacing={2}>
          <Grid item xs={3} sm={3} lg={3}>
            <table className="table100 centerDiv padTbl">
              <tbody>
                {data[0]?.Report ? (
                  <tr>
                    <td>
                      REPORT :
                    </td>
                    <td>
                      {data[0]?.Report}

                    </td>
                  </tr>
                ) : null}
                {/* {runDate ? (
                  <tr>
                    <td className="cardSmallTitle labelColor">
                      RUN DATE:
                    </td>
                    <td>
                      {runDate}
                    </td>
                  </tr>
                ) : null} */}


                {runDate && <tr>
                  <td style={{ textAlign: 'start', fontWeight: 'bold' }} className="cardSmallTitle labelColor">
                    RUN DATE:  <span style={{ marginLeft: '5px' }}> {moment(runDate).format('MM/DD/YYYY')}</span>
                  </td>
                  {/* <td style={{ textAlign: "center" }}>
                  

                  </td> */}
                </tr>}
                {data[0]?.RunYear_ID ? (
                  <tr>
                    <td style={{ textAlign: 'start', fontWeight: 'bold' }} className="cardSmallTitle labelColor">
                      RUN ID : <span style={{ marginLeft: '5px' }}> {data[0]?.RunYear_ID.split('-').splice(1, data[0]?.RunYear_ID.split('-').length - 1).join(' ')}</span>
                    </td>

                  </tr>
                ) : null}



              </tbody>
            </table>
          </Grid>
          <Grid item xs={6} sm={6} lg={6}>
            <div style={{ fontWeight: 'bold', textAlign: 'center', width: '100%' }}  >
              <p style={{ fontSize: '14px', letterSpacing: '2px' }} className=" labelColor"> GOVERNMENT OF GUAM</p>
              <p style={{ fontSize: '14px', letterSpacing: '2px', textTransform: 'capitalize' }} className=" labelColor">{departmentName?.toUpperCase()}</p>
              <p style={{ fontSize: '14px', letterSpacing: '2px', textTransform: 'capitalize' }} className=" labelColor">{title?.toUpperCase()}</p>
              <div style={{ display: 'flex', justifyContent: 'center', gap: '10px' }}>
                {check_Date && <p style={{ fontSize: '14px', letterSpacing: '2px', textTransform: 'capitalize' }} className=" labelColor">Check Date:<span style={{ marginLeft: '5px' }}> {moment(check_Date).format('MM/DD/YYYY')}</span></p>}
                {ppeEnddate && <p style={{ fontSize: '14px', letterSpacing: '2px', textTransform: 'capitalize' }} className=" labelColor"> PPE Date: <span style={{ marginLeft: '5px' }}> {ppeEnddate}</span></p>}
              </div>

            </div>
            {/* <table className="table100 centerDiv padTbl">
              <tbody>
                <tr>
                  <td style={{ textAlign: 'center', fontWeight: 'bold' }} colSpan={2}>
                    Government of Guam
                  </td>
                </tr>
                {departmentName && <tr>

                  <td style={{ textAlign: 'center', fontWeight: 'bold' }} colSpan={2} className="t18">
                    {departmentName}
                  </td>
                </tr>}
                <tr>
                  <td style={{ textAlign: 'center' }} colSpan={2} className="t18">
                    <b  >{title}</b>
                  </td>
                </tr>

              </tbody>
            </table> */}
          </Grid>
          <Grid item xs={3} sm={3} lg={3} style={{ padding: 'auto 5px' }}>
            <table className="table100 centerDiv padTbl">
              <tbody>
                {data[0]?.PageNo ? (
                  <tr>
                    <td className="cardSmallTitle labelColor">
                      <b> PAGE NO : </b>
                      {"215"}
                    </td>
                  </tr>
                ) : null}




                {runTime && <tr>
                  <td className="cardSmallTitle labelColor" style={{ fontWeight: 'bold' }}>
                    Run Time:<span style={{ marginLeft: '5px' }}> {runTime}</span>
                    {/* {data[0]?.RunTime} */}
                  </td >

                </tr >}




              </tbody >
            </table >
            {onReRunPayroll  && <button onClick={connectWebSocket} className='btn btn-primary'>
              {loading ? (<Spinner style={{ width: "14px", height: "14px", marginRight: "5px" }} />) : ""}
              Re Run Payroll
            </button>}
          </Grid >
        </Grid>

      </div >
    </>
  )
}

export default Header